import lozad from 'lozad';

export default {
	init() {

		var container = document.querySelectorAll('.fleet');

		if( container.length !=0 ) {

			var main = document.querySelector('main');

			function SelectRefresh(type) {

				var selfURL = window.location.href+'?category='+type+'&js=yes';
				var cars = document.querySelector('.fleet__cars');			

				setTimeout(

					function(){

						var req = new XMLHttpRequest();

						req.onreadystatechange = function(){

							if ( req.readyState==4 && req.status==200 ) {

								cars.remove();

								document.querySelector('.fleet__header').insertAdjacentHTML('afterend', req.responseText);				

								main.classList.remove('load');
							}

						}

						req.open('GET', selfURL, false); 
						req.setRequestHeader("Content-type", "text/json");
						req.send();

						var pictureObserverAfterLoadDOM = lozad('.lazy-load-item', {
			    			threshold: 0,
			    			loaded: function(el) {
			                    el.classList.add('asset-loaded');
			                }
						});
						pictureObserverAfterLoadDOM.observe();

					},500

				);				

			}

			function SelectChange() {

				var select = document.querySelector('.fleet .row__select');
				var values = document.querySelectorAll('.fleet .row__select li');
				var selectValues = document.querySelector('.fleet .row__select button input');

				select.addEventListener('click',function(event) {

					event.stopPropagation();

					if( select.classList.contains('active') ) {

						select.classList.remove('active');

					} else {

						select.classList.add('active');

					}

				});

				values.forEach( function( li, index ){

					li.addEventListener('click' , function(evnt){

						event.stopPropagation();

						main.classList.add('load');

						selectValues.value = li.textContent;
						select.classList.remove('active');

						values.forEach( function( li2, index2 ) {

							if( index == index2 ) {

								li.classList.add('hide');

							} else {

								li2.classList.remove('hide');

							}

						});

						if( li.getAttribute('data-cat') == null ) {

							history.pushState(null,null, window.location.origin+'/wypozyczalnia' );		

						} else {
					
							history.pushState(null,null, window.location.origin+'/wypozyczalnia/flota/'+li.getAttribute('data-cat') );

						}

						

						// history.pushState(null,null,'/flota/'+li.getAttribute('data-cat') );

						SelectRefresh( li.getAttribute('data-cat') );

					});

				});

				document.addEventListener('click' , function(){

					select.classList.remove('active');

				});

			}

			SelectChange();

		}

	},
	finalize() {
		// JavaScript to be fired on the home page, after the init JS
	},
};
